import StandardGateway from '@ad-scripts/adapters/gateways/lib/standard_gateway/standard_gateway';

/**
 * Detailed Debugging Tools Gateway
 */

const LOOKUP_ADAPTER_TIMEOUT = 16000; // 15 second lookup adapter timeout + 1 second buffer for supernova

export default class DetailedLookupDebuggingGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/customer-extensions/:customerId/integrations/:integrationId/debug-info');
  }

  fetchDetailedDebugging(params, data) {
    let url = this.endpoint.set(params).addUrl;
    return this.http.post(`${url}`, data, { timeout: LOOKUP_ADAPTER_TIMEOUT }).then(dto => dto);
  }
}
